module.exports = __webpack_public_path__ + "img/IMG_8618_L_Black_MockedUp.bd4bdd53.jpg";